// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_COURSES,
  ADD_COURSE,
  UPDATE_COURSE,
  DELETE_COURSE,
  REQUEST_COURSE,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getCourses = ({ dispatch }, contactId) => {
  dispatch(REQUEST_COURSE)
  return new Promise((resolve, reject) => {
    Vue.http
      .get('course/contact/' + contactId)
      .then(
        (response) => {
          dispatch(GET_COURSES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Add a new course
 * @param dispatch
 * @param course
 */
export const addCourse = ({ dispatch }, course) => {
  dispatch(REQUEST_COURSE)
  Vue.http
    .post('course', course)
    .then(
      (response) => {
        let data = response.json()
        dispatch(ADD_COURSE, data.course)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a course
 *
 * @param dispatch
 * @param oldCourse The former course data
 * @param newCourse The new course data
 */
export const editCourse = ({ dispatch }, oldCourse, newCourse) => {
  dispatch(REQUEST_COURSE)
  Vue.http
    .put('course/' + newCourse.id, newCourse)
    .then(
      (response) => {
        dispatch(UPDATE_COURSE, oldCourse, newCourse)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a course
 *
 * @param dispatch
 * @param job
 */
export const deleteCourse = ({ dispatch }, course) => {
  dispatch(REQUEST_COURSE)
  Vue.http.delete('course/' + course.id)
    .then(
      (response) => {
        dispatch(DELETE_COURSE, course)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/coursesActions.js